import _get from 'lodash/get';
import { DataFeedsState } from './reducer';
import { DataFeeds } from './types';

export const getDataFeeds = ({ dataFeeds }: { dataFeeds: DataFeedsState }): DataFeeds =>
  _get(dataFeeds, ['feeds'], {});
export const getError = ({ dataFeeds }: { dataFeeds: DataFeedsState }) =>
  _get(dataFeeds, 'error', '');
export const getIsDataFetching = ({ dataFeeds }: { dataFeeds: DataFeedsState }): boolean =>
  _get(dataFeeds, 'isFetching', false);
